export default __webpack_public_path__ + "static/media/DSC05588.d3c49460.jpg";